// extracted by mini-css-extract-plugin
export default {"wrapper":"NA-z","button":"OA-z","alternate":"PA-z","disabled":"QA-z","paymentWarning":"RA-z","fadeIn":"SA-z"};